
const Definition = {

    plan_level: 1,
    id: "launchpad",
    name: "Launchpad",
    path: "host/launchpad/components/Landing",
    preview_image: "https://img.freepik.com/free-vector/gradient-rocket-background_23-2148146034.jpg?semt=ais_hybrid&w=740&q=80",
    colors: {
        red: "#EF4444",
        dark: "#0A0A0F",
        text: "#E8E8F0",
        gold: "#C9A84C",
        green: "#22C55E",
        dark2: "#111118",
        dark3: "#1A1A24",
        dark4: "#22222E",
        muted: "#7A7A96",
        accent: "#4F6EF7",
        orange: "#F97316",
        gold_light: "#E8C96A",
    }

};

export default Definition;
